import angular from "angular";
import { IQpLoading } from "./IQpLoading";
import { IQpLoadingOption } from "./IQpLoadingOption";
import { IQpLoadingRootScopeService } from "./IQpLoadingRootScopeService";

export class QpLoadingProvider {

    public $get = ["$rootScope", "$templateCache", "$timeout", "$compile",
        function ($scope: IQpLoadingRootScopeService, $templateCache: angular.ITemplateCacheService, $timeout: angular.ITimeoutService, $compile: angular.ICompileService) {

            let isOpen = false;
            let options: IQpLoadingOption;

            let defaultOptions: IQpLoadingOption = {
                delay: 10000
            };

            let loadingInstance: IQpLoading = {
                open: function (openOptions?: IQpLoadingOption) {
                    $timeout(function () {
                        if (!isOpen) {
                            options = angular.extend({}, defaultOptions, openOptions);

                            let contentElem = $($templateCache.get("qp-loading-template.html") as string);
                            
                            let content = contentElem[0];

                            if (!options.appendTo) {
                                options.appendTo = $("body")[0];
                                contentElem.addClass("fixed-position");
                            }else{
                                contentElem.addClass("absolute-position");
                            }
                            options.appendTo.appendChild(content);
                            $compile(content)($scope);

                            isOpen = true;
                            $scope.$qp_loading_close_enabled = false;

                            $timeout(function () {
                                $scope.$qp_loading_close_enabled = true;
                            }, options.delay);
                        }
                    });
                },
                close: function () {
                    $timeout(function () {
                        if (isOpen) {
                            if (options.appendTo) {
                                let child = $(options.appendTo).children(".qp-loading")[0];

                                if (child) {
                                    options.appendTo.removeChild(child);
                                }

                                isOpen = false;

                                if (options.closed) {
                                    options.closed();
                                }
                            }
                        }
                    });
                }
            }

            $scope.$qp_loading_click = function () {
                loadingInstance.close();
            }

            $scope.$qp_loading_close_enabled = false;

            return loadingInstance;
        }
    ];

}